import { useEffect, useRef, useState } from "react";

export default function ShareButton() {
  const [status, setStatus] = useState<"idle" | "copied" | "failed">("idle");
  const timer = useRef<number | null>(null);

  useEffect(
    () => () => {
      if (timer.current) window.clearTimeout(timer.current);
    },
    []
  );

  const finish = (next: "copied" | "failed") => {
    setStatus(next);
    if (timer.current) window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setStatus("idle"), 2400);
  };

  const copyLink = async () => {
    const url = window.location.href;
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(url);
        finish("copied");
        return;
      }
      throw new Error("clipboard unavailable");
    } catch {
      try {
        const area = document.createElement("textarea");
        area.value = url;
        area.setAttribute("readonly", "true");
        area.style.position = "fixed";
        area.style.opacity = "0";
        document.body.appendChild(area);
        area.select();
        const done = document.execCommand("copy");
        document.body.removeChild(area);
        finish(done ? "copied" : "failed");
      } catch {
        finish("failed");
      }
    }
  };

  return (
    <div className="relative">
      <button
        type="button"
        onClick={copyLink}
        className="flex h-10 items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 font-label text-sm text-foreground-800 transition-colors hover:border-accent-500 hover:text-accent-500"
      >
        <i className={status === "copied" ? "ri-check-line text-accent-500" : "ri-link"} />
        {status === "copied" ? "链接已复制" : "分享影片"}
      </button>
      {status === "failed" && (
        <p className="absolute right-0 top-12 w-56 rounded-md border border-background-300 bg-background-100 p-3 font-label text-xs leading-relaxed text-foreground-700">
          当前浏览器不允许自动复制，请手动复制地址栏链接。
        </p>
      )}
    </div>
  );
}